<!--
  대쉬보드 > 방화벽 > 프로토콜별 추이 위젯
  @since 2022-06-09
  @author jungmin87.kim
-->

<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <div ref="chartWrapperOpts"
         class="widget-contents-option"
    >
      <div style="flex: 1"/>
      <q-select style="width: 80px;"
                class="bs bs-q-sm bs-q-select bs-q-select-default"
                :value="opts.unit"
                :options="sortByOptions"
                @change="onChangeChartOptions"
      />
    </div>
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <trend-chart ref="chartInstance"
                     class="widget-contents-chart"
                     :grid="{ left: '55px', right: '1%'}"
                     :data="widgetData"
                     :x-axis="xAxis"
                     :y-axis="yAxis"
                     :series="series"
                     :tooltip="tooltip"
                     :zoom="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 차트 컴포넌트
  import {top10ColorArea} from '~/utils/charts'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 스토어 헬퍼 객체
  const {mapGetters} = createNamespacedHelpers('common/common/')
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetFwProtocolTrafTrend',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 3,
        self: this,
        opts: {
          unit: 'bps'
        },
        title: 'widgetFwProtocolTrafTrend',
        haType: 'all',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [20],
        // isIpType: true,
        allUpdate: false,
        widgetData: [],
        timerValue: 10000,
        timerObject: null,
        lastEndTime: '',
        //, symbol: 'circle', showSymbol: false, triggerLineEvent: true
        series: [
          { id: 'prtcTcpIn', type: 'line', name: 'TCP', smooth: 0.6, valueYField: 'in_tcp', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[0] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'prtcTcpOut', type: 'line', name: 'TCP', smooth: 0.6, valueYField: 'out_tcp', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[0] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'prtcUdpIn', type: 'line', name: 'UDP', smooth: 0.6, valueYField: 'in_udp', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[1] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'prtcUdpOut', type: 'line', name: 'UDP', smooth: 0.6, valueYField: 'out_udp', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[1] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'prtcIcmpIn', type: 'line', name: 'ICMP', smooth: 0.6, valueYField: 'in_icmp', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[2] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'prtcIcmpOut', type: 'line', name: 'ICMP', smooth: 0.6, valueYField: 'out_icmp', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[2] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'prtcOthersIn', type: 'line', name: 'Others', smooth: 0.6, valueYField: 'in_other', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[3] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'prtcOthersOut', type: 'line', name: 'Others', smooth: 0.6, valueYField: 'out_other', lineStyle: {width: 1}, areaStyle: { color: top10ColorArea[3] }, symbol: 'circle', showSymbol: false, triggerLineEvent: true }
        ],
        xAxisRawData: {
          type: 'time',
          axisLine: {onZero: true},
          axisLabel: {
            formatter: '{HH}:{mm}:{ss}  ',
            hideOverlap: true
          }
        },
        yAxisRawData: [
          {
            name: 'In',
            max: 1,
            min: -1,
            type: 'value',
            position: 'left',
            axisLabel: {
              formatter: value => this.opts.unit === 'bps' ? this.bpsConverter(Math.abs(value)) : this.ppsConverter(Math.abs(value))
            },
            nameLocation: 'center',
            nameRotate: 0,
            nameGap: 80,
            nameTextStyle: {
              verticalAlign: 'bottom',
              lineHeight: this.isMaximumWidget ? 400 : 80
            }
          },
          {
            name: 'Out',
            type: 'value',
            position: 'left',
            nameLocation: 'center',
            nameRotate: 0,
            nameGap: 80,
            nameTextStyle: {
              verticalAlign: 'top',
              lineHeight: this.isMaximumWidget ? 400 : 80
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters([
        'getDeviceTime'
      ]),
      xAxis: {
        get () {
          return this.xAxisRawData
        },
        set (options) {
          this.xAxisRawData = options
        }
      },
      yAxis: {
        get () {
          return this.yAxisRawData
        },
        set (options) {
          this.yAxisRawData = options
        }
      },
      tooltip () {
        return {
          axisPointer: {type: 'line'},
          formatter: (params) => {
            const dictLabelName = {
              'prtcTcpIn': 'TCP (In)',
              'prtcTcpOut': 'TCP (Out)',
              'prtcUdpIn': 'UDP (In)',
              'prtcUdpOut': 'UDP (Out)',
              'prtcIcmpIn': 'ICMP (In)',
              'prtcIcmpOut': 'ICMP (Out)',
              'prtcOthersIn': 'Others (In)',
              'prtcOthersOut': 'Others (Out)'
            }
            let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
            for (let i = 0, max = params.length; i < max; i++) {
              const traffic = Math.abs(params[i].value[1])
              const seriesName = _.get(dictLabelName, [params[i].seriesId], '')
              resFormat += `${params[i].marker}${seriesName} : <b>${this.opts.unit === 'bps' ? this.bpsConverter(traffic) : this.ppsConverter(traffic)}</b><br>`
            }
            return resFormat
          }
        }
      },
      sortByOptions () {
        return [
          {
            label: 'bps',
            value: 'bps'
          },
          {
            label: 'pps',
            value: 'pps'
          }
        ]
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      // this.setRealtimeTimer()
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // this.clearRealtimeTimer()
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      setYAxisMaxValue () {
        const chart = this.$refs.chartInstance
        const {dataMax, dataMin} = chart.yAxis[0].getExtremes()
        let allMaxValue = (dataMax > Math.abs(dataMin)) ? dataMax : Math.abs(dataMin)
        allMaxValue = (allMaxValue === 0) ? 100 : allMaxValue * 1.1

        // chart.yAxis[0].setExtremes(-allMaxValue, allMaxValue)
        chart.yAxis[0].update({
          min: -allMaxValue,
          max: allMaxValue
        })
      },
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async onChangeChartOptions (value) {
        this.opts.unit = value
        this.getWidgetContentsData(true)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        let contentsOptions = {
          widgetType: 'protocol_traffic_trend'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        if (this.opts.haMember) {
          contentsOptions.dataType = this.opts.haMember
        }

        // 엑스트라 파라미터가 있는 경우 (IP Type 또는 HA Mamber를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams) {
          if (extraParams.machId) {
            contentsOptions.machId = extraParams.machId
          }

          if (extraParams.haMember) {
            contentsOptions.dataType = extraParams.haMember
          }
        }

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag 가 True 면 기존 차트 데이터 초기
        if (init) {
          // 타이머 재설치
          // this.setRealtimeTimer()

          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // 요청 전 차트 업데이트 처리지정
        this.allUpdate = init

        // API 호출
        const {code, eTime, result, reason} = await this.getWidgetData(contentsOptions)

        // 마지막 시간 저장 (14:04:59 저장)
        this.lastEndTime = eTime

        // Series 데이터 구성
        if (code === 'ok') {
          const unit = this.opts.unit === 'bps' ? 'bytes' : 'packets'
          let inbound = { tcp: [], udp: [], icmp: [], other: [] }
          let outbound = { tcp: [], udp: [], icmp: [], other: [] }
          let maxVal = 0

          if (result.result.length > 0) {
            for (const trafficData of result.result) {
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `in_tcp_${unit}`, 0)))
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `in_udp_${unit}`, 0)))
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `in_icmp_${unit}`, 0)))
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `in_other_${unit}`, 0)))
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `out_tcp_${unit}`, 0)))
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `out_udp_${unit}`, 0)))
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `out_icmp_${unit}`, 0)))
              maxVal = Math.max(maxVal, Math.abs(_.get(trafficData, `out_other_${unit}`, 0)))

              inbound.tcp.push([trafficData.time, _.get(trafficData, `in_tcp_${unit}`)])
              outbound.tcp.push([trafficData.time, _.get(trafficData, `out_tcp_${unit}`)])

              inbound.udp.push([trafficData.time, _.get(trafficData, `in_udp_${unit}`)])
              outbound.udp.push([trafficData.time, _.get(trafficData, `out_udp_${unit}`)])

              inbound.icmp.push([trafficData.time, _.get(trafficData, `in_icmp_${unit}`)])
              outbound.icmp.push([trafficData.time, _.get(trafficData, `out_icmp_${unit}`)])

              inbound.other.push([trafficData.time, _.get(trafficData, `in_other_${unit}`)])
              outbound.other.push([trafficData.time, _.get(trafficData, `out_other_${unit}`)])
            }

            this.yAxis[0].max = maxVal + (maxVal * 0.1) || 1
            this.yAxis[0].min = -maxVal - (maxVal * 0.1) || -1

            this.widgetData = [inbound.tcp, outbound.tcp, inbound.udp, outbound.udp, inbound.icmp, outbound.icmp, inbound.other, outbound.other]
          } else {
            // TAMS - All update 기준
            // 위젯 데이터 초기화
            this.widgetData = []

            // Series 초기화
            this.$refs.chartInstance.clear()
          }

          this.apiCallFail = false
          this.apiCallFailMsg = ''
        } else {
          this.apiCallFail = true
          this.apiCallFailMsg = reason === 404 ? 404 : 400
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    },
    watch: {}
  }
</script>
<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-option {
    right: 0;
    display: flex;
    padding-top: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
  }

  .widget-contents {
    display: flex;
  }

  .widget-contents-wrapper {
    flex: 1;
    display: flex;
    position: relative;
  }

  .widget-contents-option {
    right: 0;
    z-index: 10;
    display: flex;
    position: absolute;
    padding-top: 5px;
    padding-right: 17px;
    margin-bottom: 5px;
  }

  .widget-contents-chart {
    flex: 1 !important;
  }
</style>
